import useSWR from "swr";

export const useCategoryItem = (searchQuery, productionId) => {
    let clientsKey;
    if (searchQuery) {
        const params = new URLSearchParams({ searchParams: searchQuery });
        if (productionId) {
            params.append('productionId', productionId.toString());
        }
        clientsKey = `/production-category-item/search-production-category-item?${params.toString()}`;
    } else if (productionId) {
        clientsKey = `/production-category-item?productionId=${productionId}`;
    } else {
        clientsKey = `/production-category-item`;
    }
    
    const { data, error, mutate } = useSWR(clientsKey);

    return {
        category_item: data,
        isLoading: !error && !data,
        error,
        mutate,
    };
};